/**
 * EmailJS Configuration for Contact Form
 * Configuración de EmailJS para el formulario de contacto
 */

// Inicializar EmailJS con tu Public Key
emailjs.init("d_58bwS9omzoCi8cS"); // Reemplazar con tu public key de EmailJS

// Configuración de templates
window.EMAILJS_CONFIG = {
  serviceID: "service_41uow5c", // Reemplazar con tu Service ID

  // Templates para formulario básico (contact-with-map)
  basicTemplates: {
    confirmation: "template_qvqqvbc", // Email al cliente
    notification: "template_0bzaatb", // Email a la empresa
  },

  // Templates para formulario simple (contact-form-extended)
  simpleTemplates: {
    confirmation: "template_4qmgiwh", // Email al cliente
    notification: "template_v3ugzag", // Email a la empresa
  },

  companyEmail: "nicolas.torres@copargo.cl",
  logo_url:
    "https://cdn.shopify.com/s/files/1/0699/0243/4466/files/Copargo_Control_H_1_e3b22cf4-0a0d-48af-bbc3-1dd2455e1a2a.png?v=1767974465",
  whatsapp_number: "56999821304",
  DRY_RUN: false, // Si true, simula el envío sin contactar a EmailJS
};

function injectConfigData(formData) {
  if (!formData.logo_url) formData.logo_url = EMAILJS_CONFIG.logo_url;
  if (!formData.whatsapp_number)
    formData.whatsapp_number = EMAILJS_CONFIG.whatsapp_number;
  return formData;
}

// Función para enviar emails de contacto (formulario básico)
window.sendContactEmail = function (formData) {
  formData = injectConfigData(formData);
  return new Promise((resolve, reject) => {
    if (EMAILJS_CONFIG.DRY_RUN) {
      console.log("DRY RUN: sendContactEmail called with data:", formData);
      if (window.quotationCart && window.quotationCart.showNotification) {
        window.quotationCart.showNotification(
          "modo PRUEBA: ¡Mensaje enviado (simulado)!",
          "success",
        );
      }
      // Simular delay de red
      setTimeout(() => {
        resolve({ status: 200, text: "OK (DRY RUN)" });
      }, 1000);
      return;
    }

    // Enviar email de confirmación al cliente
    emailjs
      .send(
        EMAILJS_CONFIG.serviceID,
        EMAILJS_CONFIG.basicTemplates.confirmation,
        formData,
      )
      .then(function (response) {
        console.log("Email de confirmación enviado al cliente:", response);

        // Enviar email de notificación a la empresa
        return emailjs.send(
          EMAILJS_CONFIG.serviceID,
          EMAILJS_CONFIG.basicTemplates.notification,
          formData,
        );
      })
      .then(function (response) {
        console.log("Email de notificación enviado a la empresa:", response);
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "¡Mensaje enviado correctamente! Nos pondremos en contacto contigo pronto.",
            "success",
          );
        }
        resolve(response);
      })
      .catch(function (error) {
        console.error("Error al enviar emails:", error);
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "Error al enviar el mensaje. Por favor, intenta de nuevo.",
            "error",
          );
        }
        reject(error);
      });
  });
};

// Función para enviar emails de contacto simple (formulario extendido)
window.sendExtendedContactEmail = function (formData) {
  formData = injectConfigData(formData);
  return new Promise((resolve, reject) => {
    if (EMAILJS_CONFIG.DRY_RUN) {
      console.log(
        "DRY RUN: sendExtendedContactEmail called with data:",
        formData,
      );
      if (window.quotationCart && window.quotationCart.showNotification) {
        window.quotationCart.showNotification(
          "modo PRUEBA: ¡Solicitud enviada (simulada)!",
          "success",
        );
      }
      setTimeout(() => {
        resolve({ status: 200, text: "OK (DRY RUN)" });
      }, 1000);
      return;
    }

    // Enviar email de confirmación al cliente
    emailjs
      .send(
        EMAILJS_CONFIG.serviceID,
        EMAILJS_CONFIG.simpleTemplates.confirmation,
        formData,
      )
      .then(function (response) {
        console.log(
          "Email simple de confirmación enviado al cliente:",
          response,
        );

        // Enviar email de notificación a la empresa
        return emailjs.send(
          EMAILJS_CONFIG.serviceID,
          EMAILJS_CONFIG.simpleTemplates.notification,
          formData,
        );
      })
      .then(function (response) {
        console.log(
          "Email simple de notificación enviado a la empresa:",
          response,
        );
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "¡Solicitud enviada correctamente! Nos pondremos en contacto contigo pronto.",
            "success",
          );
        }
        resolve(response);
      })
      .catch(function (error) {
        console.error("Error al enviar emails simples:", error);
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "Error al enviar la solicitud. Por favor, intenta de nuevo.",
            "error",
          );
        }
        reject(error);
      });
  });
};

// Función alternativa para el formulario simple (si quieres usar nombres diferentes)
window.sendSimpleContactEmail = function (formData) {
  formData = injectConfigData(formData);
  return new Promise((resolve, reject) => {
    if (EMAILJS_CONFIG.DRY_RUN) {
      console.log(
        "DRY RUN: sendSimpleContactEmail called with data:",
        formData,
      );
      if (window.quotationCart && window.quotationCart.showNotification) {
        window.quotationCart.showNotification(
          "modo PRUEBA: ¡Solicitud enviada (simulada)!",
          "success",
        );
      }
      setTimeout(() => {
        resolve({ status: 200, text: "OK (DRY RUN)" });
      }, 1000);
      return;
    }

    // Enviar email de confirmación al cliente
    emailjs
      .send(
        EMAILJS_CONFIG.serviceID,
        EMAILJS_CONFIG.simpleTemplates.confirmation,
        formData,
      )
      .then(function (response) {
        console.log(
          "Email simple de confirmación enviado al cliente:",
          response,
        );

        // Enviar email de notificación a la empresa
        return emailjs.send(
          EMAILJS_CONFIG.serviceID,
          EMAILJS_CONFIG.simpleTemplates.notification,
          formData,
        );
      })
      .then(function (response) {
        console.log(
          "Email simple de notificación enviado a la empresa:",
          response,
        );
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "¡Solicitud enviada correctamente! Nos pondremos en contacto contigo pronto.",
            "success",
          );
        }
        resolve(response);
      })
      .catch(function (error) {
        console.error("Error al enviar emails simples:", error);
        if (window.quotationCart && window.quotationCart.showNotification) {
          window.quotationCart.showNotification(
            "Error al enviar la solicitud. Por favor, intenta de nuevo.",
            "error",
          );
        }
        reject(error);
      });
  });
};
